import { Crisp } from 'crisp-sdk-web'

import { app } from '../../app.module'

app
  // ユーザー名パネル用のディレクティブ
  .directive('userNamePanel', () => {
    return {
      template: require('./user-name-panel.pug')(),
      restrict: 'E',
      controller: function ($rootScope, $scope, $state, $location, userNamePanelService) {
        // ユーザー情報を取得
        userNamePanelService.getUserData().then((userData) => {
          // ユーザー名をパネルに表示
          $scope.userName = userData.userName
          // ユーザー画像をセット
          $scope.userImage = userData.pictureUrl
          // ルートスコープにユーザー情報をセット
          $rootScope.userName = userData.userName
          $rootScope.userId = userData.userId
          $rootScope.pictureUrl = userData.pictureUrl

          // 更新通知フラグがONの場合はフラグをOFFにセットして保存
          if (userData.userNotificationFlg === 1 && $location.search().notification === '1') {
            userData.userNotificationFlg = 0
            userNamePanelService.saveUserNotificationFlg(userData)
          }

          // チャットサポートツールにデータをセット
          if (Crisp.isCrispInjected()) {
            const prefix = process.env.NODE_ENV === 'development' ? 'dev_' : ''

            Crisp.user.setEmail(userData.userEmail)
            Crisp.user.setNickname(userData.userName)
            if (userData.pictureUrl) {
              Crisp.user.setAvatar(userData.pictureUrl)
            }
            Crisp.session.setSegments([`${prefix}post365_user`], false)
            Crisp.session.setData({ [`${prefix}post365_user_id`]: userData.userId })
            Crisp.session.pushEvent(`${prefix}post365:login`)
          }

          // 対象ユーザーのグループリストを取得
          $scope.groupsList = userData.groupsList.split('-')
          // 対象ユーザーの管理権限をチェック
          checkGroupAdmin()
        })

        // 画面を表示
        $scope.stateGo = function (stateName) {
          $state.go(stateName)
        }

        // グループIDを変更するイベント
        $scope.$watch(
          () => {
            return $rootScope.groupId
          },
          () => {
            // 対象ユーザーの管理権限をチェック
            checkGroupAdmin()
          }
        )

        /**
         * 対象ユーザーの管理権限をチェック
         */
        function checkGroupAdmin() {
          // グループIDが存在しないまたは対象ユーザーのグループ一覧が存在しない場合、リターン
          if ($rootScope.groupId === undefined || $scope.groupsList === undefined) {
            return
          }

          for (let i = 0; i < $scope.groupsList.length; i = i + 1) {
            const group = JSON.parse($scope.groupsList[i])

            if (group.groupId === $rootScope.groupId) {
              $rootScope.isGroupAdmin = group.isGroupAdmin === 1 ? true : false
              break
            }
          }
        }

        // ディレクティブから'changeUserInfo'を受信した場合
        const removeEvent = $rootScope.$on('changeUserInfo', (event, userInfo) => {
          // ユーザー名をパネルに表示
          $scope.userName = userInfo.data.username
          // ユーザー画像をセット
          $scope.userImage = userInfo.data.picture
          // ルートスコープにユーザー情報をセット
          $rootScope.userName = userInfo.data.username
        })

        // ディレクティブが消える際には、$rootScopeのイベントの監視を削除
        $scope.$on('$destroy', () => {
          removeEvent()
        })
      },
    }
  })
